import React, { useEffect, useState, useRef } from "react";
import { useHistory } from 'react-router-dom';
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import api from "~/services/api";
import ApiBullets from "~/services/Bulletins/api";
import apiLapidar from '~/services/Lapidar/api';
import CloseIcon from "@material-ui/icons/Close";
import Loading from "~/components/layout/Loading";
import { formatCNPJ, capitalizeFirstLetter, checkSubString } from '~/utils/utils';
import { 
  CloseIconContainer,
  ModalContent,
  Title,
  ButtonArea,
  Button,
  ButtonLink,
  BodyContent,
  Caption
} from '../styles';

export default function NotificationModal({ showModalPopup, setShowModalPopup, notification}) {
  const host_name = window.location.host;
  const history = useHistory(); 
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(showModalPopup);
  const [loading, setLoading] = useState(false);

  const header = {
    'Content-Type': 'application/json',
    access_token: localStorage.getItem('access_token'),
  };
  const parameters = {
    headers: header,
  };

  useEffect(() => {
    setShowModal(showModalPopup);
    dispatch({ type: "SET_ACTIVE_POPUP", activePopup: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModalPopup]);

  useEffect(() => {
    let document = localStorage.getItem('storeDocument');
    if (document && document != 'undefined'){
      document = formatCNPJ(document);
    }

    fetchTracking({
      bulletinsid: notification.id,
      cnpj: document
    })

    if (!notification.hiperlinks && !notification.content) {
      fetchTrackingRead(notification.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function fetchTracking(payload) {
    try {
      await api
      .put(
        '/customer-relationship/sitel/v1/calls',
        payload,
        parameters
      )
      .then(res => {
      })
      .catch(err => {
        console.log("Error tracking call - popup.", err);
      });
    } catch (error) {
      console.warn("Exceção in tracking - Popup.", error);
      return false
    }
  }

  async function fetchTrackingRead(id) {
    let document = localStorage.getItem('storeDocument');
    if (document && document != 'undefined'){
      document = formatCNPJ(document);
    }

    try {
      await api
      .put(
        '/customer-relationship/sitel/v1/reads',
        {
          bulletinsid: id,
          cnpj: document
        },
        parameters
      )
      .then(res => {
      })
      .catch(err => {
        console.log("Error tracking read - details.", err);
      });
    } catch (error) {
      console.warn("Exceção in read - details.", error);
      return false
    }
  }

  function onClosePopup() {
    setShowModal(false);
    setShowModalPopup(false);
    dispatch({ type: "SET_ACTIVE_POPUP", activePopup: false });
  }

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => onClosePopup() }
        centered
        className="notification-modal"
        size="lg" 
        style={{width: '100vw', margin: 0, padding: 0  }}
      >
        <CloseIconContainer>
          <CloseIcon onClick={() => onClosePopup()} />
        </CloseIconContainer>
        <Modal.Body>
        {
          loading ? <Loading /> : (
            <>
              <ModalContent>
                <Title>
                  <span>{notification?.title && notification.title}</span>
                </Title>
                <Caption>
                  {notification?.caption && notification.caption}
                </Caption>
                {notification?.hiperlinks && (
                    <ButtonArea>
                      <Button
                        onClick={() => {
                          onClosePopup();
                          fetchTrackingRead(notification.id);
                          window.open(
                            notification.hiperlinks,
                            checkSubString(notification.hiperlinks, host_name) ? "_self" : "_blank"
                          );
                        }}                      
                      >
                        Saiba mais
                      </Button>
                    </ButtonArea>
                  )}
                  {!notification?.hiperlinks && notification?.content && (
                    <ButtonArea>
                      <Button
                        onClick={() => {
                          onClosePopup();
                          history.push(`/segmented-comunication-details?id=${notification.id}`)
                        }}
                      >
                        Saiba mais
                      </Button>
                    </ButtonArea>
                  )}
              </ModalContent>
            </>
          )
        }
        </Modal.Body>
      </Modal>
    </>
  );
}
